import BeyondWords from "@beyondwords/player";

document.addEventListener("DOMContentLoaded", () => {
  Array.from(document.getElementsByClassName("beyondwords-player")).forEach(
    (element: HTMLElement) => {
      const { projectId, sourceId } = element.dataset;

      if (projectId && sourceId) {
        const player = new BeyondWords.Player({
          target: element,
          projectId: projectId,
          sourceId: sourceId,
          clientSideEnabled: true,
          highlightSections: "none",
          logoIconEnabled: false
        });
        player.addEventListener("ContentAvailable", () => {
          element.classList.add("available");
        });
      }
    }
  );
});
